export class Controller {

    /** @ngInject */
    constructor($state, $translate, Alert, GroupsResource) {
        this.$state = $state;
        this.$translate = $translate;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
    }

    csvImportAvailable() {
        return this.group.directory && this.group.directory.type == 'AD';
    }

    resendVerifications() {

        this.isSaving = true;

        this.Alert('info', 'company.user-directories.directory-groups.directory.bulk-verification.re-sending-verifications');

        this.GroupsResource
            .resendVerifications(this.companyId, this.group)
            .then(() => {
                this.Alert('success', 'company.user-directories.directory-groups.directory.bulk-verification.re-sending-verifications-success');
            })
            .catch(() => {
                this.Alert('danger', 'company.user-directories.directory-groups.directory.bulk-verification.re-sending-verifications-error');
            })
            .finally(() => this.isSaving = false)
    }

    templateUrl() {
        return require(`./bulk-verification-${this.$translate.use()}.html`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/bulk-verification/bulk-verification.controller.js